module.exports = __webpack_public_path__ + "img/ic_star.78a06da3.svg";